import angular from 'angular';
import creditworthinessOfLoanComponent from './creditworthinessOfLoan.component';

let creditworthinessOfLoanModule = angular.module('creditworthinessOfLoan', [
])

.component('creditworthinessOfLoan', creditworthinessOfLoanComponent)

.name;

export default creditworthinessOfLoanModule;



// WEBPACK FOOTER //
// ./client/app/loans.module/features/creditworthiness/creditworthinessOfLoan/creditworthinessOfLoan.js